module.exports = __webpack_public_path__ + "img/upgrade-nan-img.67b04cd8.png";